module.exports = __webpack_public_path__ + "media/react/marketing/sections/value_props/assets/purple/video_lessons_icon-69fa25f35a379fd65c0279476aa61757.svg";